import React from "react";
import { Button, Typography } from "antd";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const CancelOrder = () => {
    const navigate = useNavigate();

    return (
        <div className="bg-black text-white mt-[140px] py-[60px] flex flex-col items-center justify-center">
            <div className="text-center p-8 border border-[#333] rounded-2xl max-w-md">
                <Title level={3} style={{ color: "#ff4d4d" }}>
                    Payment Cancelled
                </Title>
                <Text style={{ color: "#bbb" }}>
                    You cancelled your PayPal payment. Your order has not been processed.
                </Text>
                <div className="mt-6 flex gap-3 justify-center">
                    <Button
                        type="primary"
                        style={{
                            background: "#00e0ff",
                            border: "none",
                            color: "#000",
                            fontWeight: 600,
                            borderRadius: "50px",
                        }}
                        onClick={() => navigate("/checkout")}
                    >
                        Try Again
                    </Button>
                    <Button
                        type="default"
                        style={{
                            background: "#222",
                            border: "1px solid #444",
                            color: "#fff",
                            fontWeight: 600,
                            borderRadius: "50px",
                        }}
                        onClick={() => navigate("/")}
                    >
                        Back to Home
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default CancelOrder;
